"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var BodySection_1 = require("./BodySection");
var Utils_1 = require("./Utils");
function calculateTopMargin(headerHeight, showHeaders) {
    return showHeaders ? headerHeight + 2 : 0;
}
var Body = /** @class */ (function (_super) {
    __extends(Body, _super);
    function Body() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // used to exclude scrollbar width from body width calculations
        _this.clientWidth = 0;
        // used to exclude scrollbar height from body height calculations
        _this.clientHeight = 0;
        _this.scrollLeft = 0;
        _this.scrollTop = 0;
        // tslint:disable-next-line
        _this.state = {};
        _this.handleScrollableRefUpdated = function (s) {
            _this.scrollable = s;
            _this.updateClientWidthAndHeight();
            if (_this.props.onIScrollableRefUpdate) {
                _this.props.onIScrollableRefUpdate(s);
            }
        };
        _this.onScroll = function (left, top) {
            _this.scrollLeft = left;
            _this.scrollTop = top;
            _this.props.onBodyScroll(left, top);
        };
        return _this;
    }
    Body.prototype.componentDidMount = function () {
        this.focusRow(this.props.requestedFocusedRowIndex);
    };
    Body.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.requestedFocusedRowIndex !== this.props.requestedFocusedRowIndex) {
            this.focusRow(nextProps.requestedFocusedRowIndex);
        }
        else if (nextProps.rememberLastScrollPos) {
            if (!this.isScrollTopPosValidForNextProps(nextProps)) {
                this.scrollToTop();
            }
        }
    };
    Body.prototype.componentDidUpdate = function () {
        this.updateClientWidthAndHeight();
        if (!this.isScrollTopPosValidForBodySectionRenderRanges(this.props.bodySectionRenderRanges)) {
            this.props.onBodyScroll(this.scrollLeft, this.scrollTop);
        }
    };
    Body.prototype.updateClientWidthAndHeight = function () {
        if (!this.scrollable) {
            return;
        }
        var scrollNode = ReactDOM.findDOMNode(this.scrollable);
        if (scrollNode) {
            this.clientHeight = scrollNode.clientHeight;
            this.clientWidth = scrollNode.clientWidth;
        }
    };
    Body.prototype.render = function () {
        var bodySectionRenderRanges = this.props.bodySectionRenderRanges;
        var rows = this.props.rows;
        var scrollComponentProps = {
            marginTop: calculateTopMargin(this.props.headerHeight, this.props.showHeaders),
            rootCssClass: 'tb-react-dg-body',
            scrollingRootId: this.props.scrollingRootId,
            onScroll: this.onScroll,
            onRefUpdated: this.handleScrollableRefUpdated
        };
        // tslint:disable-next-line:no-any
        var sections;
        var sectionsStyle;
        var actualTotalColumnWidth = this.props.totalColumnWidth + (this.props.leftMargin || 0);
        if (!rows.length) {
            sections = this.props.emptyChild;
            sectionsStyle = {
                width: (actualTotalColumnWidth > this.clientWidth) ? actualTotalColumnWidth : '100%',
                height: '100%'
            };
        }
        else {
            sections = this.renderSections();
            var topSpacer = bodySectionRenderRanges.rowStart * this.props.sectionHeight;
            sectionsStyle = {
                paddingTop: topSpacer,
                paddingLeft: this.props.leftSpacer,
                height: rows.length * this.props.rowOuterHeight - topSpacer,
                width: (actualTotalColumnWidth > this.clientWidth) ? (actualTotalColumnWidth - this.props.leftSpacer) : '100%'
            };
        }
        return React.createElement(this.props.scrollComponent, scrollComponentProps, (React.createElement("div", { style: sectionsStyle }, sections)));
    };
    Body.prototype.onRowStoreChanged = function () {
        // e.g. after filtering to an empty list. Skip scrollToTop; re-init.
        if (!this.props.rememberLastScrollPos) {
            this.scrollToTop();
        }
    };
    Body.prototype.scrollToTop = function () {
        this.scrollRowIntoView(0);
    };
    // tslint:disable-next-line:no-any
    Body.prototype.renderSections = function () {
        var bodySectionRenderRanges = this.props.bodySectionRenderRanges;
        // tslint:disable-next-line:no-any
        var sections = [];
        var colStartIdx = bodySectionRenderRanges.columnStart * this.props.colsPerChunk;
        var colEndIdx = Math.min((bodySectionRenderRanges.columnEnd + 1) * this.props.colsPerChunk, this.props.cols.length) - 1;
        for (var i = bodySectionRenderRanges.rowStart; i <= bodySectionRenderRanges.rowEnd; i++) {
            var rowStartIdx = i * this.props.sectionRows;
            var rowEndIdx = Math.min((i + 1) * this.props.sectionRows, this.props.rows.length);
            sections.push(BodySection_1.BodySection.element({
                key: i,
                cols: this.props.cols,
                colStartIdx: colStartIdx,
                colEndIdx: colEndIdx,
                columnWidths: this.props.columnWidths,
                leftMargin: this.props.leftMargin,
                measuredColumnWidths: this.props.measuredColumnWidths,
                measureColumnWidths: i === bodySectionRenderRanges.rowStart ? this.props.measureColumnWidths : undefined,
                rows: this.props.rows,
                rowStartIdx: rowStartIdx,
                rowEndIdx: rowEndIdx,
                focusedRowIndex: Utils_1.isNumber(this.state.focusedRowIndex) ? this.state.focusedRowIndex : undefined,
                rowStylist: this.props.rowStylist,
                onCellClick: this.props.onCellClick,
                onCellDoubleClick: this.props.onCellDoubleClick,
                onCellContextMenu: this.props.onCellContextMenu,
                onRowClick: this.props.onRowClick,
                selectionData: this.props.selectionData,
                isSelectionDataIndexBased: this.props.isSelectionDataIndexBased,
                showRowHeaders: this.props.showRowHeaders,
                showHorizontalGridLines: this.props.showHorizontalGridLines,
                showVerticalGridLines: this.props.showVerticalGridLines,
                rowOuterHeight: this.props.rowOuterHeight
            }));
        }
        return sections;
    };
    Body.prototype.isScrollTopPosValidForNextProps = function (nextProps) {
        var nextRowCount = nextProps.rows.length;
        var nextRowOuterHeight = nextProps.rowOuterHeight;
        if (nextRowCount === this.props.rows.length && nextRowOuterHeight === this.props.rowOuterHeight) {
            return true;
        }
        return this.scrollTop <= (nextRowCount * nextRowOuterHeight);
    };
    Body.prototype.isScrollTopPosValidForBodySectionRenderRanges = function (bodySectionRenderRanges) {
        var firstRowTopPx = bodySectionRenderRanges.rowStart * this.props.sectionRows * this.props.rowOuterHeight;
        var lastRowBottomPx = (bodySectionRenderRanges.rowEnd + 1) * this.props.sectionRows * this.props.rowOuterHeight;
        var rowsInViewPort = Math.ceil(this.clientHeight / this.props.rowOuterHeight);
        if (this.props.rows.length > rowsInViewPort) {
            lastRowBottomPx -= (rowsInViewPort * this.props.rowOuterHeight);
        }
        return this.scrollTop >= Math.max(firstRowTopPx, 0) && this.scrollTop <= Math.max(lastRowBottomPx, 0);
    };
    Body.prototype.focusRow = function (rowIndex) {
        var _this = this;
        if (Utils_1.isNumber(rowIndex)) {
            this.setState({
                focusedRowIndex: Math.min(Math.max(rowIndex, 0), this.props.rows.length - 1)
            }, function () {
                if (Utils_1.isNumber(_this.state.focusedRowIndex)) {
                    if (_this.props.onRowFocused) {
                        _this.props.onRowFocused(_this.props.rows[_this.state.focusedRowIndex], _this.state.focusedRowIndex);
                    }
                    _this.scrollRowIntoView(_this.state.focusedRowIndex);
                }
            });
        }
        else {
            this.setState({ focusedRowIndex: undefined });
        }
    };
    Body.prototype.scrollRowIntoView = function (rowIndex) {
        var _this = this;
        if (!this.scrollable) {
            return;
        }
        var viewPortRect = ReactDOM.findDOMNode(this).getBoundingClientRect();
        var viewPortHeight = viewPortRect.height - this.scrollable.getScrollbarWidth();
        var rowTop = rowIndex * this.props.rowOuterHeight;
        var rowBottom = rowTop + this.props.rowOuterHeight;
        var scrollTop = this.scrollTop;
        if (rowTop < scrollTop) {
            setTimeout(function () {
                if (!!_this.scrollable) {
                    _this.scrollable.setScrollPosition(null, rowTop);
                }
            }, 0);
        }
        else if (rowBottom > scrollTop + viewPortHeight) {
            setTimeout(function () {
                if (!!_this.scrollable) {
                    _this.scrollable.setScrollPosition(null, rowBottom - viewPortHeight);
                }
            }, 0);
        }
    };
    Body.displayName = 'DataGridBody';
    Body.element = React.createFactory(Body);
    return Body;
}(React.Component));
exports.Body = Body;
//# sourceMappingURL=Body.js.map